import { ReportProps, ValidationError, Validator } from "../../../../../types/types";
import { StringUtils } from "../../../../../utils/stringUtils";


export class JrxmlFormPageValidation implements Validator<ReportProps> {
    validate(props: ReportProps): ValidationError[] {
        const info=props.reportInfo;
        const errors: ValidationError[] = [];
        if(props.valueReportType === 'jrxml'){
        if (StringUtils.isEmpty(info.reportDefenition))
            errors.push(new ValidationError("reportDefenitionError", "Please provide Jrxml path !"))
        }
        else{
        if (!info.extendedAttributes?.headers || Object.keys(info.extendedAttributes.headers).length === 0)
            errors.push(new ValidationError("simpleReportError", "Please select report columns !"))
    }
       return errors;
    }
}